import { j as r } from "./atoms-v218.js";
import { forwardRef as u } from "react";
import { Description as v, TopBar as p, Title as d, Content as t, SpecsContainer as g, SpecsList as m, Vertical as f, VerticalContainer as L, VerticalInnerContainer as S, Subhead as _, ExpressiveContent as C, GridSpecs as T, Pictures as P } from "./atoms-v21030.js";
import { Column as $ } from "./atoms-v212.js";
import { Picture as y } from "./atoms-v233.js";
import { useBreakpoints as x } from "./atoms-v251.js";
import { Grid as I } from "./atoms-v216.js";
const M = 2, V = {
  small: "3/2",
  medium: "3/4",
  large: "1/1",
  xLarge: "1/1",
  max: "1/1"
}, E = ({ content: e, specs: s, title: i }) => {
  const { current: a } = x();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(p, { large: 8, offset: { xLarge: 1 }, small: 4, xLarge: 14 }),
    /* @__PURE__ */ r.jsx(
      $,
      {
        large: 3,
        max: 6,
        medium: 8,
        offset: { xLarge: 1, max: 1 },
        small: 4,
        span: 5,
        xLarge: 6,
        children: /* @__PURE__ */ r.jsx(d, { children: i })
      }
    ),
    /* @__PURE__ */ r.jsxs(
      t,
      {
        large: 5,
        max: 7,
        medium: 8,
        offset: { xLarge: 1, max: 1 },
        small: 4,
        span: 8,
        xLarge: 7,
        children: [
          typeof e == "string" ? /* @__PURE__ */ r.jsx("div", { dangerouslySetInnerHTML: { __html: e } }) : e,
          s && /* @__PURE__ */ r.jsx(g, { children: /* @__PURE__ */ r.jsx(m, { variant: a === "small" ? "vertical" : "horizontal", children: s }) })
        ]
      }
    )
  ] });
}, R = ({ content: e, specs: s, title: i }) => {
  const { current: a } = x();
  return /* @__PURE__ */ r.jsx(f, { large: 8, max: 14, medium: 8, small: 4, xLarge: 14, children: /* @__PURE__ */ r.jsx(I, { children: /* @__PURE__ */ r.jsxs(
    L,
    {
      large: 6,
      max: 8,
      medium: 6,
      offset: { large: 1, max: 4, xLarge: 3 },
      small: 4,
      xLarge: 10,
      children: [
        /* @__PURE__ */ r.jsxs(S, { children: [
          /* @__PURE__ */ r.jsx(d, { children: i }),
          /* @__PURE__ */ r.jsx(t, { $variant: "v2", children: typeof e == "string" ? /* @__PURE__ */ r.jsx("div", { dangerouslySetInnerHTML: { __html: e } }) : e })
        ] }),
        s && /* @__PURE__ */ r.jsx(m, { $variant: "v2", variant: a === "small" ? "vertical" : "horizontal", children: s })
      ]
    }
  ) }) });
}, z = ({ content: e, pictures: s = [], specs: i, title: a }) => {
  const { current: l } = x(), n = ["max", "xLarge", "large"].includes(l) ? s.slice(0, M) : s.slice(0, 1), o = ["medium", "large", "xLarge"].includes(l), h = n.length > 1, j = V[l];
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      t,
      {
        $variant: "v3",
        large: 4,
        max: 8,
        medium: 4,
        offset: { xLarge: 1, max: 1 },
        small: 4,
        span: 8,
        xLarge: 7,
        children: [
          a && /* @__PURE__ */ r.jsx(_, { children: a }),
          /* @__PURE__ */ r.jsx(C, { children: typeof e == "string" ? /* @__PURE__ */ r.jsx("div", { dangerouslySetInnerHTML: { __html: e } }) : e }),
          /* @__PURE__ */ r.jsxs(g, { children: [
            i && !o && /* @__PURE__ */ r.jsx(m, { $variant: "v3", variant: l === "small" ? "vertical" : "horizontal", children: i }),
            i && o && /* @__PURE__ */ r.jsx(T, { $variant: "v3", variant: l === "small" ? "vertical" : "horizontal", children: i })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ r.jsx(
      P,
      {
        $hasMultiplePictures: h,
        large: 4,
        max: 5,
        medium: 4,
        offset: { max: 1, xLarge: 1 },
        small: 4,
        span: 6,
        xLarge: 6,
        children: (n == null ? void 0 : n.length) > 0 ? n.map((c) => /* @__PURE__ */ r.jsx(y, { aspectRatio: j, ...c }, c.defaultSource)) : null
      }
    )
  ] });
}, A = u(
  ({ className: e, content: s, id: i, variant: a = "v1", ...l }, n) => /* @__PURE__ */ r.jsxs(
    v,
    {
      $variant: a,
      className: e,
      hAlign: a === "v2" ? "center" : "start",
      id: i,
      ref: n,
      tagName: "article",
      vAlign: a === "v3" ? "stretch" : "start",
      children: [
        a === "v1" && /* @__PURE__ */ r.jsx(E, { content: s, ...l }),
        a === "v2" && /* @__PURE__ */ r.jsx(R, { content: s, ...l }),
        a === "v3" && /* @__PURE__ */ r.jsx(z, { content: s, ...l })
      ]
    }
  )
);
A.displayName = "Blocks.Description";
export {
  A as Description
};
